import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 md:py-16 px-4 bg-brand-dark border-y border-brand-accent/20" data-id="element-107">
      <div className="max-w-3xl mx-auto text-center" data-id="element-108">
        <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-brand-accent rounded-full mb-6 shadow-lg" data-id="element-109">
          <ShieldCheck className="w-8 h-8 md:w-10 md:h-10 text-white" data-id="element-110" />
        </div>

        <h2 className="text-2xl md:text-4xl font-black mb-6 text-brand-accent neon-glow" data-id="element-111">
          🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <div className="text-lg md:text-xl font-medium space-y-3 mb-8 text-gray-300" data-id="element-112">
          <p data-id="element-113">Abrís los tomos. Los usás en el aula.</p>
          <p data-id="element-114">Si en 7 días no es lo que esperabas:</p>
          <div className="flex flex-col items-center justify-center gap-2 mt-4 mb-4" data-id="element-115">
            <p className="text-xl md:text-2xl font-black text-white bg-brand-card inline-block px-6 py-2 rounded-lg border border-brand-accent/30" data-id="element-116">
              👉 devolución del 100%
            </p>
            <p className="text-xl md:text-2xl font-black text-white bg-brand-card inline-block px-6 py-2 rounded-lg border border-brand-accent/30" data-id="element-117">
              👉 sin formularios
            </p>
            <p className="text-xl md:text-2xl font-black text-white bg-brand-card inline-block px-6 py-2 rounded-lg border border-brand-accent/30" data-id="element-118">
              👉 sin vueltas
            </p>
          </div>
        </div>

        <p className="text-sm md:text-base text-gray-500 font-semibold bg-brand-card inline-block px-4 py-1.5 rounded-full border border-white/10" data-id="element-119">
          Tasa de devoluciones: menos del 1%
        </p>
      </div>
    </section>;
}